export default __webpack_public_path__ + "static/media/TotalAssetsLabeled.3e78781e.svg";